import {
	ArrayContainer,
	ArrayContainerNoData,
	ArrayContainerRow,
	ArrayContainerRows,
	DeskComponentRegistry
} from '@component';

DeskComponentRegistry.register({
	array: ArrayContainer,
	'array.rows': ArrayContainerRows,
	'array.row': ArrayContainerRow,
	'array.nodata': ArrayContainerNoData
});

export const DeskArrayContainer = ArrayContainer;
export const DeskArrayContainerRow = ArrayContainerRow;
export const DeskArrayContainerNoData = ArrayContainerNoData;
